module.exports = __webpack_public_path__ + "static/media/editPen.f36e8b38.svg";